import {createGlobalStyle} from 'styled-components';

import {optional, optionalPx} from '@shared_web/lib/styled_utils';

export const GlobalStyle = createGlobalStyle`
  html,
  body,
  #root {
    width: 100%;
    height: calc(env(safe-area-inset-top) + 100% + env(safe-area-inset-bottom));
    font-weight: 400;
    ${p => optional('font-family', p.theme.main?.fontFamily)};
    ${p => optionalPx('font-size', p.theme.main?.fontSize)};
    ${p => optionalPx('line-height', p.theme.main?.lineHeight)};
    ${p => optional('background-color', p.theme.main?.backgroundColor)};
    ${p => optional('color', p.theme.main?.textColor)};
  }

  [hidden] {
    display: none !important;
  }
`;
